import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderSl = () => {
    return (
        <HighlightedText
            text="POSTRGANI SREČKE IN PREVZEMITE SVOJ BONUS"
            highlights={[
                { word: 'PREVZEMITE' },
                { word: 'SVOJ' },
                { word: 'BONUS' },
            ]}
            breakAfterWords={['IN']}
            className={styles.text_header}
        />
    )
}
